module.exports = __webpack_public_path__ + "img/8blue.f593eae5.png";